import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    content: String,
    classlist: Array
  }

  connect() {
    this.tooltipElem = null
    if (this.contentValue == '') {
      console.error("Tooltip controller initialized w/out `data-tooltip-content-value` attribute set.")
    } else {
      this.initFunctionality()
    }
  }

  initFunctionality() {
    this.appendAfterElement()
    this.element.addEventListener('mouseenter', (e) => this.tooltipElem.classList.remove('hidden'))
    this.element.addEventListener('mouseleave', (e) => this.tooltipElem.classList.add('hidden'))
  }

  appendAfterElement() {
    this.element.classList.add("relative", "overflow-x-visible")
    this.tooltipElem = document.createElement('div')
    this.tooltipElem.classList.add("hidden", "absolute", "top-0", "left-0", "p-2", "text-black", "bg-white", "rounded", "shadow-md", "overflow-y-scroll", "max-w-3xl", "z-40", "min-w-[100px]")
    this.tooltipElem.style.maxHeight = "160px"
    this.tooltipElem.classList.add(...this.classlistValue)
    var parser = new DOMParser();
    var doc = parser.parseFromString(this.contentValue, 'text/html');
    this.tooltipElem.innerHTML = doc.body.innerText
    this.element.append(this.tooltipElem)
  }

}